import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCartAndRedirect } from '../lib/metaPixel';
const CHECKOUT_URL = 'https://www.legadosalud.com/cart/42499535011925:1';
export function Hero() {
  const goToCheckout = () => {
    trackAddToCartAndRedirect(CHECKOUT_URL, {
      content_name: 'El Protocolo Meno-Metabólico',
      content_ids: ['42499535011925'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  return <section className="relative bg-gradient-to-b from-[#faf6ee] to-[#f5f0e6] pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-78">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-80">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-81">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight text-[#2d2d2d] mb-6" data-id="element-82">
              Cómo Desinflamar tu Cuerpo, Dominar tus Bochornos y Recuperar tu
              Peso Ideal en 21 Días...
            </h1>

            <p className="text-xl md:text-2xl text-[#5d6e4f] mb-4 font-medium" data-id="element-83">
              Sin Hormonas, Sin Dietas de Hambre y Sin Gastar una Fortuna en el
              Gimnasio.
            </p>

            <p className="text-lg text-[#7a8a6b] mb-8 italic" data-id="element-84">
              (Diseñado específicamente para mujeres mayores de 50 años)
            </p>

            <div className="h-px bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mb-8" data-id="element-85"></div>

            <p className="text-lg md:text-xl text-[#2d2d2d] mb-10 leading-relaxed" data-id="element-86">
              Descubre el método paso a paso para resetear tu metabolismo y
              volver a dormir profundamente, usando ingredientes que ya tienes
              en tu cocina.
            </p>

            <motion.button onClick={goToCheckout} whileHover={{
            scale: 1.05,
            y: -2
          }} whileTap={{
            scale: 0.98
          }} className="bg-[#5d6e4f] text-white px-10 py-4 rounded-lg text-lg font-semibold shadow-lg hover:bg-[#4a5940] transition-colors" data-id="element-87">
              DESCÁRGALO AHORA POR $6,39 USD
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2" data-id="element-88">
            <img src="https://cdn.magicpatterns.com/uploads/hmS7w43reDpjcC1KX8HJp8/Portada.png" alt="El Protocolo Meno-Metabólico" className="w-full max-w-md mx-auto rounded-lg shadow-2xl" data-id="element-89" />
          </motion.div>
        </div>
      </div>
    </section>;
}